import dayjs from 'dayjs';

const checkIsValidDate = date => {
  if (isNaN(date) || (typeof date === 'string' && isNaN(Number(date)))) {
    return false;
  }

  let newDate = typeof date === 'string' ? parseInt(date) : date;

  try {
    return new Date(newDate * 1000);
  } catch {
    return false;
  }
};

export const expiresDateFormatting = val => {
  if (!val || !checkIsValidDate(val)) {
    return null;
  }

  try {
    return dayjs(new Date(Number(val) * 1000)).format('YYYY-MM-DDTHH:mm:ssZ');
  } catch {
    return null;
  }
};
